import React, { useEffect, useState } from "react";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { SweetAlertShow, LoadingDiv } from "../master/Master";
import { studentAdd, studentRegistrationNo } from "../../api/Student";
import { districtsList, statesList } from "../../api/Locations";
import { StaffList } from "../../api/Staff";
import useAppConfig from "../config/useAppConfig";
import { useLocation, useNavigate } from "react-router-dom";
import Master from "./Master";
import { enquiryDetail } from "../../api/Enquiry";

export default function StudentAdd() {
  const config = useAppConfig("Student", "admission_fields");
  const navigate = useNavigate();
  const [loading, setLoading] = useState("");
  const [sessions, setSessions] = useState([]);
  const [states, setStates] = useState([]);
  const [staffs, setStaffs] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [data, setData] = useState({ registration_no: false });
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const enquiry_id = params.get("enquiry_id") ?? "";

  const [profilePicture, setProfilePicture] = useState(null);
  const [profilePreview, setProfilePreview] = useState(null);

  const handleProfilePicture = (e) => {
    const file = e.target.files?.[0];

    if (!file) return;

    setProfilePicture(file);
    setProfilePreview(URL.createObjectURL(file));
  };

  const getEnquiryStudent = async () => {
    setLoading(true);
    try {
      const response = await enquiryDetail(enquiry_id);
      if (response.data.status) {
        console.log("enquiry se addmission data", response.data);
        setData(response.data.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (enquiry_id) {
      getEnquiryStudent();
    }
  }, [enquiry_id]);

  const getRegistrationNo = async () => {
    setLoading(true);
    try {
      let addUrl = "";
      if (data?.registration_no) {
        addUrl += `registration_no=${data?.registration_no}`;
      }
      const response = await studentRegistrationNo(addUrl);
      if (response.data.status) {
        setData((prev) => ({
          ...prev,
          ...(!prev.registration_no && {
            registration_no: response?.data?.data?.next_registration_no,
          }),
          message: response?.data?.data?.message,
        }));
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };
  const getStaffs = async () => {
    const addUrl = `status=1`;
    setLoading(true);
    try {
      const response = await StaffList(addUrl);
      if (response.data.status) {
        setStaffs(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getStatesList = async () => {
    setLoading(true);
    try {
      const response = await statesList();
      if (response.data.status) {
        setStates(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getDistrictList = async () => {
    setLoading(true);
    try {
      let addUrl = ``;
      if (data?.state) {
        addUrl += `state=${data?.state}`;
      }
      const response = await districtsList(addUrl);
      if (response.data.status) {
        setDistricts(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const parseSessions = JSON.parse(localStorage.getItem("sessions") ?? "[]");
    setSessions(parseSessions);
  }, []);

  useEffect(() => {
    setData({
      ...data,
      session_id: sessions?.find((s) => Number(s.status) === 1)?.id,
    });
  }, [sessions]);

  useEffect(() => {
    getRegistrationNo();
  }, [data?.registration_no]);

  useEffect(() => {
    getStatesList();
    getStaffs();
  }, []);

  useEffect(() => {
    getDistrictList();
  }, [data?.state]);

  const [educationList, setEducationList] = useState([
    {
      course_name: data?.last_eduction ?? "",
      school_name: data?.last_institute_name ?? "",
      year: "",
      score: "",
    },
  ]);

  const addRow = () => {
    setEducationList([
      ...educationList,
      { course_name: "", school_name: "", year: "", score: "" },
    ]);
  };

  const handleEducationChange = (value, field, index) => {
    const list = [...educationList];
    list[index][field] = value;
    setEducationList(list);
  };

  useEffect(() => {
    if (data?.last_eduction) {
      handleEducationChange(data?.last_eduction, "course_name", 0);
    }
    if (data?.last_institute_name) {
      handleEducationChange(data?.last_institute_name, "school_name", 0);
    }
  }, [data]);

  const removeRow = (index) => {
    const list = [...educationList];
    list.splice(index, 1);
    setEducationList(list);
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      if (profilePicture) {
        formData.append("image", profilePicture);
      }
      const response = await studentAdd(formData);
      if (response?.data?.status) {
        navigate(
          `/student/batch/enroll?student_id=${response?.data?.data?.id}`,
        );
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const fieldConfig = (() => {
    try {
      return JSON.parse(config?.value || "[]");
    } catch {
      return [];
    }
  })();

  const getField = (name) => {
    return (
      fieldConfig.find((f) => f.field === name) || {
        show: 1,
        required: 0,
      }
    );
  };

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <Master />
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                        <h4 className="text-primary mb-0">Student Admission</h4>
                        <hr />
                        <form onSubmit={handleAdd} method="get">
                          {data?.id && (
                            <input
                              type="text"
                              className="form-control"
                              name="enquiry_id"
                              value={data?.id}
                              required
                            />
                          )}

                          <div className="row g-4">
                            <div className="col-12">
                              <h5 className="text-primary mb-0">
                                Basic Details
                              </h5>
                            </div>
                            <div className="col-lg-4 col-sm-6">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="registration_no"
                                  value={data?.registration_no}
                                  onChange={(e) =>
                                    setData({
                                      ...data,
                                      registration_no: e.target.value,
                                    })
                                  }
                                  required
                                  placeholder="Registration No"
                                />
                                <label htmlFor="registration_no">
                                  Registration No
                                  <sup className="text-danger">*</sup>
                                </label>
                              </div>
                              {data?.message && (
                                <p className="m-0 text-danger">
                                  {" "}
                                  {data?.message}
                                </p>
                              )}
                            </div>

                            <div className="col-lg-4 col-sm-6">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="text"
                                  className="form-control "
                                  name="name"
                                  value={data?.name || data?.student_name}
                                  onChange={(e) =>
                                    setData({
                                      ...data,
                                      name: e.target.value,
                                    })
                                  }
                                  required
                                  placeholder="Name"
                                />
                                <label htmlFor="name">
                                  Name
                                  <sup className="text-danger">*</sup>
                                </label>
                              </div>
                            </div>
                            <div className="col-lg-4 col-sm-6">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="number"
                                  className="form-control"
                                  name="phone"
                                  value={data?.phone || data?.mobile}
                                  onChange={(e) =>
                                    setData({
                                      ...data,
                                      phone: e.target.value,
                                    })
                                  }
                                  required
                                  placeholder="Phone No"
                                />
                                <label htmlFor="phone">
                                  Phone No <sup className="text-danger">*</sup>
                                </label>
                              </div>
                            </div>
                            {getField("secondary_mobile").show === 1 && (
                              <div className="col-lg-4 col-sm-6">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="secondary_mobile"
                                    placeholder="Secondary Mobile No "
                                    value={data?.secondary_mobile}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        secondary_mobile: e.target.value,
                                      })
                                    }
                                    required={
                                      getField("secondary_mobile").required ===
                                      1
                                    }
                                  />
                                  <label>
                                    Secondary Mobile No{" "}
                                    {getField("secondary_mobile").required ===
                                      1 && (
                                        <span className="text-danger">*</span>
                                      )}
                                  </label>
                                </div>
                              </div>
                            )}
                            {getField("father_name").show === 1 && (
                              <div className="col-lg-4 col-sm-6">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="text"
                                    className="form-control "
                                    name="father_name"
                                    value={data?.father_name}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        father_name: e.target.value,
                                      })
                                    }
                                    required={
                                      getField("father_name").required === 1
                                    }
                                    placeholder="Father Name"
                                  />
                                  <label htmlFor="father_name">
                                    Father Name
                                    {getField("father_name").required === 1 && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </label>
                                </div>
                              </div>
                            )}
                            {getField("mother_name").show === 1 && (
                              <div className="col-lg-4 col-sm-6">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="text"
                                    className="form-control "
                                    name="mother_name"
                                    value={data?.mother_name}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        mother_name: e.target.value,
                                      })
                                    }
                                    required={
                                      getField("mother_name").required === 1
                                    }
                                    placeholder="Mother Name"
                                  />
                                  <label htmlFor="mother_name">
                                    Mother Name
                                    {getField("mother_name").required === 1 && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </label>
                                </div>
                              </div>
                            )}
                            {getField("father_occupation").show === 1 && (
                              <div className="col-lg-4 col-sm-6">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="father_occupation"
                                    value={data?.father_occupation}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        father_occupation: e.target.value,
                                      })
                                    }
                                    required={
                                      getField("father_occupation").required ===
                                      1
                                    }
                                    placeholder="Father Occupation"
                                  />
                                  <label htmlFor="father_occupation">
                                    Father Occupation{" "}
                                    {getField("father_occupation").required ===
                                      1 && (
                                        <span className="text-danger">*</span>
                                      )}
                                  </label>
                                </div>
                              </div>
                            )}

                            {getField("father_mobile").show === 1 && (
                              <div className="col-lg-4 col-sm-6">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="father_mobile"
                                    value={data?.father_mobile || ""}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        father_mobile: e.target.value,
                                      })
                                    }
                                    required={
                                      getField("father_mobile").required === 1
                                    }
                                    placeholder="Father Mobile"
                                  />
                                  <label>Father Mobile</label>
                                </div>
                              </div>
                            )}

                            {getField("father_aadhar").show === 1 && (
                              <div className="col-lg-4 col-sm-6">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="father_aadhar"
                                    value={data?.father_aadhar || ""}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        father_aadhar: e.target.value,
                                      })
                                    }
                                    required={
                                      getField("father_aadhar").required === 1
                                    }
                                    placeholder="Father Aadhar"
                                  />
                                  <label>Father Aadhar</label>
                                </div>
                              </div>
                            )}

                            {getField("mother_mobile").show === 1 && (
                              <div className="col-lg-4 col-sm-6">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="mother_mobile"
                                    value={data?.mother_mobile || ""}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        mother_mobile: e.target.value,
                                      })
                                    }
                                    required={
                                      getField("mother_mobile").required === 1
                                    }
                                    placeholder="Mother Mobile"
                                  />
                                  <label>Mother Mobile</label>
                                </div>
                              </div>
                            )}

                            {getField("mother_aadhar").show === 1 && (
                              <div className="col-lg-4 col-sm-6">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="mother_aadhar"
                                    value={data?.mother_aadhar || ""}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        mother_aadhar: e.target.value,
                                      })
                                    }
                                    required={
                                      getField("mother_aadhar").required === 1
                                    }
                                    placeholder="Mother Aadhar"
                                  />
                                  <label>Mother Aadhar</label>
                                </div>
                              </div>
                            )}

                            {getField("caste_name").show === 1 && (
                              <div className="col-lg-4 col-sm-6">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="text"
                                    className="form-control "
                                    name="caste_name"
                                    value={data?.caste_name || ""}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        caste_name: e.target.value,
                                      })
                                    }
                                    required={
                                      getField("caste_name").required === 1
                                    }
                                    placeholder="Caste Name"
                                  />
                                  <label>Caste Name</label>
                                </div>
                              </div>
                            )}

                            {getField("religion").show === 1 && (
                              <div className="col-lg-4 col-sm-6">
                                <div className="form-floating form-floating-outline">
                                  <select
                                    className="form-select"
                                    name="religion"
                                    value={data?.religion || ""}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        religion: e.target.value,
                                      })
                                    }
                                    required={
                                      getField("religion").required === 1
                                    }
                                  >
                                    <option value="">Select Religion</option>
                                    <option value="HINDU">HINDU</option>
                                    <option value="MUSLIM">MUSLIM</option>
                                    <option value="SIKH">SIKH</option>
                                    <option value="CHRISTIAN">CHRISTIAN</option>
                                    <option value="JAIN">JAIN</option>
                                    <option value="BUDDHIST">BUDDHIST</option>
                                    <option value="OTHER">OTHER</option>
                                  </select>

                                  <label>
                                    Religion
                                    {getField("religion").required === 1 && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </label>
                                </div>
                              </div>
                            )}

                            {getField("pen_no").show === 1 && (
                              <div className="col-lg-4 col-sm-6">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="pen_no"
                                    value={data?.pen_no || ""}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        pen_no: e.target.value,
                                      })
                                    }
                                    required={getField("pen_no").required === 1}
                                    placeholder="PAN No"
                                  />
                                  <label>PAN No</label>
                                </div>
                              </div>
                            )}

                            {getField("jan_aadhar").show === 1 && (
                              <div className="col-lg-4 col-sm-6">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="jan_aadhar"
                                    value={data?.jan_aadhar || ""}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        jan_aadhar: e.target.value,
                                      })
                                    }
                                    required={
                                      getField("jan_aadhar").required === 1
                                    }
                                    placeholder="Jan Aadhar"
                                  />
                                  <label>Jan Aadhar</label>
                                </div>
                              </div>
                            )}

                            {getField("admission_class").show === 1 && (
                              <div className="col-lg-4 col-sm-6">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="text"
                                    className="form-control "
                                    name="admission_class"
                                    value={data?.admission_class || ""}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        admission_class: e.target.value,
                                      })
                                    }
                                    required={
                                      getField("admission_class").required === 1
                                    }
                                    placeholder="Admission Class"
                                  />
                                  <label>Admission Class</label>
                                </div>
                              </div>
                            )}

                            {getField("email").show === 1 && (
                              <div className="col-lg-4 col-sm-6">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="email"
                                    className="form-control"
                                    name="email"
                                    value={data?.email}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        email: e.target.value,
                                      })
                                    }
                                    required={getField("email").required === 1}
                                    placeholder="Email"
                                  />
                                  <label htmlFor="email">
                                    Email{" "}
                                    {getField("email").required === 1 && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </label>
                                </div>
                              </div>
                            )}
                            {getField("category").show === 1 && (
                              <div className="col-lg-4 col-sm-6">
                                <div className="form-floating form-floating-outline">
                                  <select
                                    name="category"
                                    className="form-select"
                                    value={data?.category}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        category: e.target.value,
                                      })
                                    }
                                    required={
                                      getField("category").required === 1
                                    }
                                  >
                                    <option value="" disabled selected>
                                      Select Category
                                    </option>
                                    <option value="GEN">GEN</option>
                                    <option value="OBC">OBC</option>
                                    <option value="EWS">EWS</option>
                                    <option value="MBC">MBC</option>
                                    <option value="SC">SC</option>
                                    <option value="ST">ST</option>
                                  </select>
                                  <label>
                                    Category{" "}
                                    {getField("category").required === 1 && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </label>
                                </div>
                              </div>
                            )}
                            {getField("gender").show === 1 && (
                              <div className="col-lg-4 col-sm-6">
                                <div className="form-floating form-floating-outline">
                                  <select
                                    className="form-select"
                                    name="gender"
                                    required={getField("gender").required === 1}
                                    value={data?.gender}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        gender: e.target.value,
                                      })
                                    }
                                  >
                                    <option value="" selected disabled>
                                      Select Gender
                                    </option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                    <option value="Other">Other</option>
                                  </select>
                                  <label htmlFor="gender">
                                    Gender{" "}
                                    {getField("gender").required === 1 && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </label>
                                </div>
                              </div>
                            )}
                            {getField("aadhar").show === 1 && (
                              <div className="col-lg-4 col-sm-6">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="aadhar"
                                    value={data?.aadhar}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        aadhar: e.target.value,
                                      })
                                    }
                                    required={getField("aadhar").required === 1}
                                    placeholder="Aadhar"
                                  />
                                  <label htmlFor="aadhar">
                                    Aadhar{" "}
                                    {getField("aadhar").required === 1 && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </label>
                                </div>
                              </div>
                            )}

                            {getField("dob").show === 1 && (
                              <div className="col-lg-4 col-sm-6">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="date"
                                    className="form-control"
                                    name="dob"
                                    value={data?.dob}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        dob: e.target.value,
                                      })
                                    }
                                    required={getField("dob").required === 1}
                                    placeholder="DOB"
                                  />
                                  <label htmlFor="dob">
                                    DOB{" "}
                                    {getField("dob").required === 1 && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </label>
                                </div>
                              </div>
                            )}
                            {getField("hostel_status").show === 1 && (
                              <div className="col-lg-4 col-sm-6">
                                <div className="form-floating form-floating-outline">
                                  <select
                                    name="hostel_status"
                                    className="form-select"
                                    value={data?.hostel_status}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        hostel_status: e.target.value,
                                      })
                                    }
                                    required={
                                      getField("hostel_status").required === 1
                                    }
                                  >
                                    <option value="" disabled selected>
                                      Select Hostel Status
                                    </option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                  </select>
                                  <label htmlFor="hostel_status">
                                    Hostel Status{" "}
                                    {getField("hostel_status").required ===
                                      1 && (
                                        <span className="text-danger">*</span>
                                      )}
                                  </label>
                                </div>
                              </div>
                            )}
                            {getField("bus_status").show === 1 && (
                              <div className="col-lg-4 col-sm-6">
                                <div className="form-floating form-floating-outline">
                                  <select
                                    name="bus_status"
                                    className="form-select"
                                    value={data?.bus_status}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        bus_status: e.target.value,
                                      })
                                    }
                                    required={
                                      getField("bus_status").required === 1
                                    }
                                  >
                                    <option value="" disabled selected>
                                      Select Bus Status
                                    </option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                  </select>
                                  <label htmlFor="bus_status">
                                    Bus Status{" "}
                                    {getField("bus_status").required === 1 && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </label>
                                </div>
                              </div>
                            )}
                            {getField("medium").show === 1 && (
                              <div className="col-lg-4 col-sm-6">
                                <div className="form-floating form-floating-outline">
                                  <select
                                    name="medium"
                                    className="form-select"
                                    value={data?.medium}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        medium: e.target.value,
                                      })
                                    }
                                    required={getField("medium").required === 1}
                                  >
                                    <option value="" disabled selected>
                                      Select Medium
                                    </option>
                                    <option value="Hindi">Hindi</option>
                                    <option value="English">English</option>
                                  </select>
                                  <label htmlFor="medium">
                                    Medium{" "}
                                    {getField("medium").required === 1 && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </label>
                                </div>
                              </div>
                            )}
                            {getField("nic_id").show === 1 && (
                              <div className="col-lg-4 col-sm-6">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="nic_id"
                                    value={data?.nic_id}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        nic_id: e.target.value,
                                      })
                                    }
                                    required={getField("nic_id").required === 1}
                                    placeholder="NIC ID"
                                  />
                                  <label htmlFor="nic_id">
                                    NIC ID{" "}
                                    {getField("nic_id").required === 1 && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </label>
                                </div>
                              </div>
                            )}
                            {getField("apaar_id").show === 1 && (
                              <div className="col-lg-4 col-sm-6">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="apaar_id"
                                    value={data?.apaar_id}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        apaar_id: e.target.value,
                                      })
                                    }
                                    required={
                                      getField("apaar_id").required === 1
                                    }
                                    placeholder="Apaar ID"
                                  />
                                  <label htmlFor="apaar_id">
                                    Apaar ID{" "}
                                    {getField("apaar_id").required === 1 && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </label>
                                </div>
                              </div>
                            )}
                            {getField("student_type").show === 1 && (
                              <div className="col-lg-4 col-sm-6">
                                <div className="form-floating form-floating-outline">
                                  <select
                                    name="student_type"
                                    className="form-select"
                                    value={data?.student_type}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        student_type: e.target.value,
                                      })
                                    }
                                    required={
                                      getField("student_type").required === 1
                                    }
                                  >
                                    <option value="" disabled selected>
                                      Select Student Type
                                    </option>
                                    <option value="student">Student</option>
                                    <option value="working_professional">
                                      Working Professional
                                    </option>
                                  </select>
                                  <label htmlFor="student_type">
                                    Student Type{" "}
                                    {getField("student_type").required ===
                                      1 && (
                                        <span className="text-danger">*</span>
                                      )}
                                  </label>
                                </div>
                              </div>
                            )}
                            {getField("admission_date").show === 1 && (
                              <div className="col-lg-4 col-sm-6">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="date"
                                    className="form-control"
                                    name="admission_date"
                                    value={
                                      data?.admission_date ||
                                      new Date().toISOString().split("T")[0]
                                    }
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        admission_date: e.target.value,
                                      })
                                    }
                                    required={
                                      getField("admission_date").required === 1
                                    }
                                    placeholder="Admission Date"
                                  />
                                  <label htmlFor="admission_date">
                                    Admission Date{" "}
                                    {getField("admission_date").required ===
                                      1 && (
                                        <span className="text-danger">*</span>
                                      )}
                                  </label>
                                </div>
                              </div>
                            )}
                            {getField("counselor_id").show === 1 && (
                              <div className="col-md-4">
                                <div className="form-floating form-floating-outline">
                                  <select
                                    name="counselor_id"
                                    className="form-control form-select"
                                    required={
                                      getField("counselor_id").required === 1
                                    }
                                  >
                                    <option value="">Select Staff</option>
                                    {staffs?.map((staff, i) => (
                                      <option key={i} value={staff?.id}>
                                        {staff?.name} ({staff?.registration_no})
                                      </option>
                                    ))}
                                  </select>
                                  <label>
                                    {" "}
                                    Assign Staff{" "}
                                    {getField("counselor_id").required ===
                                      1 && (
                                        <span className="text-danger">*</span>
                                      )}
                                  </label>
                                </div>
                              </div>
                            )}
                            {getField("referred_by").show === 1 && (
                              <div className="col-lg-4 col-sm-6">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="referred_by"
                                    value={data?.referred_by}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        referred_by: e.target.value,
                                      })
                                    }
                                    required={
                                      getField("referred_by").required === 1
                                    }
                                    placeholder="Referred By"
                                  />
                                  <label htmlFor="referred_by">
                                    Referred By{" "}
                                    {getField("referred_by").required === 1 && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </label>
                                </div>
                              </div>
                            )}
                            {getField("note").show === 1 && (
                              <div className="col-lg-4 col-sm-6">
                                <div className="form-floating form-floating-outline">
                                  <textarea
                                    className="form-control "
                                    name="note"
                                    value={data?.note}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        note: e.target.value,
                                      })
                                    }
                                    required={getField("note").required === 1}
                                    placeholder="Note"
                                  />
                                  <label htmlFor="note">
                                    Note{" "}
                                    {getField("note").required === 1 && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </label>
                                </div>
                              </div>
                            )}
                            {getField("profile_picture").show === 1 && (
                              <div className="col-lg-4 col-sm-6">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="file"
                                    accept="image/*"
                                    className="form-control"
                                    id="profile_picture"
                                    onChange={handleProfilePicture}
                                  />
                                  {profilePreview && (
                                    <div className="mt-3 text-center">
                                      <img
                                        src={profilePreview}
                                        alt="Preview"
                                        className="rounded-circle border shadow"
                                        style={{
                                          width: 120,
                                          height: 120,
                                          objectFit: "cover",
                                        }}
                                      />

                                      <div className="mt-2">
                                        <button
                                          type="button"
                                          className="btn btn-sm btn-outline-danger"
                                          onClick={() => {
                                            setProfilePicture(null);
                                            setProfilePreview(null);

                                            document.getElementById(
                                              "profile_picture",
                                            ).value = "";
                                          }}
                                        >
                                          Remove
                                        </button>
                                      </div>
                                    </div>
                                  )}
                                  <label htmlFor="profile_picture">
                                    Profile Picture{" "}
                                    {getField("profile_picture").required ===
                                      1 && (
                                        <span className="text-danger">*</span>
                                      )}
                                  </label>
                                </div>
                              </div>
                            )}

                            <div className="col-12">
                              <hr />
                              <h5 className="text-primary m-0">Address</h5>
                            </div>

                            {getField("village").show === 1 && (
                              <div className="col-lg-4 col-sm-6">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="text"
                                    className="form-control "
                                    name="village"
                                    placeholder="Village"
                                    required={
                                      getField("village").required === 1
                                    }
                                    value={data?.village}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        village: e.target.value,
                                      })
                                    }
                                  />
                                  <label>
                                    Village{" "}
                                    {getField("village").required === 1 && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </label>
                                </div>
                              </div>
                            )}
                            {getField("state").show === 1 && (
                              <div className="col-lg-4 col-sm-6">
                                <div className="form-floating form-floating-outline">
                                  <select
                                    className="form-select"
                                    name="state"
                                    value={data?.state}
                                    onChange={(e) => {
                                      setData({
                                        ...data,
                                        state: e.target.value,
                                      });
                                    }}
                                    required={getField("state").required === 1}
                                  >
                                    <option value="">Select State</option>
                                    {states?.map((state) => (
                                      <option key={state.id} value={state.name}>
                                        {state.name}
                                      </option>
                                    ))}
                                  </select>
                                  <label>
                                    State{" "}
                                    {getField("state").required === 1 && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </label>
                                </div>
                              </div>
                            )}
                            {getField("district").show === 1 && (
                              <div className="col-lg-4 col-sm-6">
                                <div className="form-floating form-floating-outline">
                                  <select
                                    className="form-select"
                                    name="district"
                                    required={
                                      getField("district").required === 1
                                    }
                                    value={data?.district}
                                    onChange={(e) => {
                                      setData({
                                        ...data,
                                        district: e.target.value,
                                      });
                                    }}
                                  >
                                    <option value="" name="district">
                                      Select District
                                    </option>
                                    {districts?.map((district) => (
                                      <option
                                        key={district.id}
                                        value={district.name}
                                      >
                                        {district.name}
                                      </option>
                                    ))}
                                  </select>
                                  <label>
                                    District{" "}
                                    {getField("district").required === 1 && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </label>
                                </div>
                              </div>
                            )}
                            {getField("zipcode").show === 1 && (
                              <div className="col-lg-4 col-sm-6">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="zipcode"
                                    placeholder="Pin Code"
                                    required={
                                      getField("zipcode").required === 1
                                    }
                                    value={data?.zipcode || data?.pin_code}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        zipcode: e.target.value,
                                      })
                                    }
                                  />
                                  <label>
                                    Pin Code{" "}
                                    {getField("zipcode").required === 1 && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </label>
                                </div>
                              </div>
                            )}

                            <div className="col-12">
                              <hr />
                              <h5 className="text-primary m-0">
                                {" "}
                                Additional Details
                              </h5>
                            </div>
                            <div className="col-12">
                              {educationList.map((item, i) => (
                                <div key={i} className="row mb-5">
                                  <div className="col-lg-3 col-md-4 col-sm-6">
                                    <div className="form-floating form-floating-outline">
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Last Education"
                                        name={`education_details[${i}][course_name]`}
                                        value={item?.course_name}
                                        onChange={(e) =>
                                          handleEducationChange(
                                            e.target.value,
                                            "course_name",
                                            i,
                                          )
                                        }
                                      />
                                      <label>Last Education</label>
                                    </div>
                                  </div>

                                  <div className="col-lg-3 col-md-4 col-sm-6">
                                    <div className="form-floating form-floating-outline">
                                      <input
                                        type="text"
                                        className="form-control "
                                        placeholder="School Name"
                                        name={`education_details[${i}][school_name]`}
                                        value={item.school_name}
                                        onChange={(e) =>
                                          handleEducationChange(
                                            e.target.value,
                                            "school_name",
                                            i,
                                          )
                                        }
                                      />
                                      <label>School Name</label>
                                    </div>
                                  </div>
                                  <div className="col-lg-2 col-md-3 col-sm-6">
                                    <div className="form-floating form-floating-outline">
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Year"
                                        name={`education_details[${i}][year]`}
                                        value={item.year}
                                        onChange={(e) =>
                                          handleEducationChange(
                                            e.target.value,
                                            "year",
                                            i,
                                          )
                                        }
                                      />
                                      <label>Year</label>
                                    </div>
                                  </div>

                                  <div className="col-lg-2 col-md-3 col-sm-6">
                                    <div className="form-floating form-floating-outline">
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Score"
                                        name={`education_details[${i}][score]`}
                                        value={item.score}
                                        onChange={(e) =>
                                          handleEducationChange(
                                            e.target.value,
                                            "score",
                                            i,
                                          )
                                        }
                                      />
                                      <label>Score</label>
                                    </div>
                                  </div>

                                  <div className="col-lg-2 d-flex align-items-center gap-2">
                                    {educationList.length !== 1 && (
                                      <button
                                        type="button"
                                        className="btn btn-danger btn-sm"
                                        onClick={() => removeRow(i)}
                                      >
                                        -
                                      </button>
                                    )}

                                    {i === 0 && (
                                      <button
                                        type="button"
                                        className="btn btn-success btn-sm"
                                        onClick={addRow}
                                      >
                                        +
                                      </button>
                                    )}
                                  </div>
                                </div>
                              ))}
                            </div>

                            <div className="col-12 text-end">
                              <button className="btn btn-sm btn-primary px-12">
                                Save
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
